import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'bidi-contextual-menu',
  templateUrl: './contextual-menu.component.html',
  styleUrls: ['./contextual-menu.component.scss']
})
export class ContextualMenuComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
